export const cookieConsentTranslations = {
  fr: {
    title: "Nous respectons votre vie privée",
    description: "Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et optimiser nos services. Vous pouvez personnaliser vos préférences ci-dessous.",
    acceptAll: "Tout accepter",
    rejectAll: "Tout refuser",
    customize: "Personnaliser",
    savePreferences: "Enregistrer mes choix",
    essentialLabel: "Essentiels",
    essentialDescription: "Nécessaires au fonctionnement du site. Toujours actifs.",
    selectAll: "Tout cocher",
    privacyLink: "Politique de confidentialité",
    services: {
      analytics: {
        name: "Google Analytics",
        description: "Mesure d'audience et statistiques de visite",
        icon: "📊"
      },
      advertising: {
        name: "Google Ads",
        description: "Mesure de performance des campagnes publicitaires",
        icon: "📈"
      },
      hotjar: {
        name: "Hotjar",
        description: "Analyse du parcours utilisateur pour améliorer l'expérience",
        icon: "🔍"
      }
    }
  },
  en: {
    title: "We respect your privacy",
    description: "We use cookies to improve your experience, analyze traffic and optimize our services. You can customize your preferences below.",
    acceptAll: "Accept All",
    rejectAll: "Reject All",
    customize: "Customize",
    savePreferences: "Save Preferences",
    essentialLabel: "Essential",
    essentialDescription: "Required for the site to function. Always active.",
    selectAll: "Select All",
    privacyLink: "Privacy Policy",
    services: {
      analytics: {
        name: "Google Analytics",
        description: "Audience measurement and visit statistics",
        icon: "📊"
      },
      advertising: {
        name: "Google Ads",
        description: "Advertising campaign performance measurement",
        icon: "📈"
      },
      hotjar: {
        name: "Hotjar",
        description: "User journey analysis to improve experience",
        icon: "🔍"
      }
    }
  },
  tr: {
    title: "Gizliliğinize saygı duyuyoruz",
    description: "Deneyiminizi iyileştirmek, trafiği analiz etmek ve hizmetlerimizi optimize etmek için çerezler kullanıyoruz. Tercihlerinizi aşağıdan özelleştirebilirsiniz.",
    acceptAll: "Tümünü Kabul Et",
    rejectAll: "Tümünü Reddet",
    customize: "Özelleştir",
    savePreferences: "Tercihlerimi Kaydet",
    essentialLabel: "Zorunlu",
    essentialDescription: "Sitenin çalışması için gereklidir. Her zaman aktif.",
    selectAll: "Tümünü Seç",
    privacyLink: "Gizlilik Politikası",
    services: {
      analytics: {
        name: "Google Analytics",
        description: "Ziyaretçi istatistikleri ve kitle ölçümü",
        icon: "📊"
      },
      advertising: {
        name: "Google Ads",
        description: "Reklam kampanya performans ölçümü",
        icon: "📈"
      },
      hotjar: {
        name: "Hotjar",
        description: "Deneyimi iyileştirmek için kullanıcı yolculuğu analizi",
        icon: "🔍"
      }
    }
  }
};
